import React, { useState, useEffect } from 'react';
import PageTitle from '@/Components/PageTitle';
import { message, Pagination, Popconfirm, Result, Space, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import userInfo from '@/Components/user';
import { jobs, deleteJob } from '@/services/common'
import TableLine from './TableLine';


const Component = (props: any) => {
  const [source, setSource] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const del_confirm: any = (id: any) => {
    deleteJob(id, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        message.success("删除成功");
        loadData();
      } else {
        message.error("删除失败");
      }
    })

  };

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [count, setCount] = useState(0);

  const loadData = () => {
    setLoading(true)
    jobs({
      page,
      perPage
    }, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        setCount(r.data.count);
        setSource(r.data.data);
      }
      setLoading(false)
    })
  }
  useEffect(() => {
    loadData();
  }, [page, perPage])

  const status = (s: string) => {
    if (s === 'done') {
      return <span style={{ color: '#14EB64' }}>已完成</span>
    } else if (s === 'pending') {
      return <span style={{ color: '#14EB64' }}>排队中</span>
    } else if (s === 'running') {
      return <span style={{ color: '#14EB64' }}>计算中</span>
    } else {
      return <span style={{ color: 'red' }}>计算错误</span>
    }
  }
  return (
    <div className="indexShow">
      <div className="indexShowMain" style={{ marginTop: "2rem" }}>
        <PageTitle
          title={`任务列表：（${count}）`}
        // extra={
        //   <Space>

        //     <div className="button new" style={{ marginLeft: '2rem' }}>+ 新建任务</div>
        //   </Space>
        // }
        />

        {
          loading ? <div className="loadingArea">
            <Spin />
          </div>
            : count === 0 ?
              <div className="noResults mt2">
                <Result
                  status="info"
                  title={<div className="t2 w">暂时没有计算任务！</div>}
                ></Result>
              </div>
              :
              <div className='indexTable mt2 maxh'>
                <table>
                  <thead>
                    <tr>
                      <th>任务名称</th>
                      {/* <th>任务描述</th> */}
                      <th>所属项目</th>
                      <th>所属流程</th>
                      <th>任务状态</th>
                      <th>创建日期</th>
                      <th>创建人</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    {source ? source.map((item: any, index: any) => {
                      return <TableLine
                        key={index}
                        item={item}
                        userInfo={userInfo}
                        del_confirm={del_confirm}
                        loadData={loadData}
                      />
                    }) : ''}
                  </tbody>
                </table>

              </div>
        }
        <div className='mt2'>
          <Pagination
            current={page}
            total={count}
            pageSize={perPage}
            hideOnSinglePage={true}
            onChange={(p: number) => setPage(p)}
            showSizeChanger={false}
          />
        </div>


      </div>
    </div>
  );
};


export default Component;